module.exports = __webpack_public_path__ + "static/media/3.9c75b341.png";